import React from 'react';

const Backend = () => {
  return (
    <div className='skills__content'>
      <h3 className='skills__title'>MLOps, GenAI & Cloud</h3>

      <div className='skills__box'>
        {/* LEFT COLUMN */}
        <div className='skills__group'>
          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>Python</h3>
              <span className='skills__level'>Advanced</span>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>Machine Learning</h3>
              <span className='skills__level'>Proficient</span>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>MLflow</h3>
              <span className='skills__level'>Proficient</span>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>DVC</h3>
              <span className='skills__level'>Proficient</span>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>ETL Pipelines</h3>
              <span className='skills__level'>Intermediate</span>
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className='skills__group'>
          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>Docker</h3>
              <span className='skills__level'>Proficient</span>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>FastAPI / APIs</h3>
              <span className='skills__level'>Intermediate</span>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>CI/CD (GitHub Actions)</h3>
              <span className='skills__level'>Intermediate</span>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>Azure (AI, ML, Container Apps)</h3>
              <span className='skills__level'>Intermediate</span>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>GenAI, RAG & LangChain</h3>
              <span className='skills__level'>Proficient</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Backend;
